export let DisplayType;

(function (DisplayType) {
  DisplayType["List"] = "list";
  DisplayType["ListSearch"] = "list_search";
  DisplayType["Range"] = "range";
})(DisplayType || (DisplayType = {}));

export let SelectionType;

(function (SelectionType) {
  SelectionType["Single"] = "single";
  SelectionType["Multi"] = "multi";
})(SelectionType || (SelectionType = {}));

export let OptionType;

(function (OptionType) {
  OptionType["Root"] = "root";
  OptionType["Default"] = "default";
  OptionType["Navigational"] = "navigational";
  OptionType["Group"] = "group";
})(OptionType || (OptionType = {}));

export let OptionExtentionType;

(function (OptionExtentionType) {
  OptionExtentionType["Color"] = "color";
})(OptionExtentionType || (OptionExtentionType = {}));